import { EntityVersionType, EntityVersion } from 'types';
import { localMoment } from 'util/Time';
import moment from 'moment';
import { ModelStatus } from '../../../Roc.SharedClientApp/types/model-status';

export class HistoryHelper {
	/**
	 * Returns a display name for a given version type.
	 */
	public static getVersionTypeName(version: EntityVersion, displayName: boolean = true): string {
		const dateFormat = 'M/D/YY hh:mm:ss A z';

		const createDate =
			version.type === EntityVersionType.Current
				? localMoment(version.modifyDate).format(dateFormat)
				: localMoment(version.createDate).format(dateFormat);
		const modifyDate = moment(version.createDate).isSame(moment(version.modifyDate))
			? undefined
			: localMoment(version.modifyDate).format(dateFormat);

		switch (version.type) {
			case EntityVersionType.Archived:
				return (displayName ? 'Archived: ' : '') + createDate;
			case EntityVersionType.Draft:
				return (
					(displayName ? 'Draft ' + (modifyDate ? 'Modified: ' : 'Created: ') : '') +
					(modifyDate ? modifyDate : createDate)
				);
			case EntityVersionType.Future:
				let action = 'Publish';
				switch (version.status) {
					case ModelStatus.Deleted:
						action = 'Deletion';
						break;
					case ModelStatus.Inactive:
						action = 'Deactivation';
						break;
				}
				const scheduledTime = version.scheduledTime
					? (displayName ? ': ' : '') + localMoment(version.scheduledTime).format(dateFormat)
					: '';
				return (displayName ? 'Scheduled ' + action : '') + scheduledTime;
			case EntityVersionType.Current:
				return (displayName ? 'Current Version: ' : '') + createDate;
			default:
				return version.type;
		}
	}
}
